import React from 'react';
import { WorkspaceListSidebar } from './WorkspaceListSidebar';
import type { WorkspaceMode } from '@auw/workspace-utils';

interface WorkspaceSidebarProps {
  mode: WorkspaceMode;
  pageSidebarOpen: boolean;
  onTogglePageSidebar: () => void;
}

export const WorkspaceSidebar: React.FC<WorkspaceSidebarProps> = (props) => {
  return <WorkspaceListSidebar {...props} />;
};
